<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<div id="lf-checklist-container" class="lf-checklist-container">
  <div id="lf-checklist-list-container" class="lf-checklist-list-container">
    @for (checklist of checklists; track checklist) {
      <div id="lf-checklist-list" class="lf-checklist-list">
        @if (!checklist.collapsible) {
          <div>
            <div id="lf-checklist-name-container" class="lf-checklist-name-container">
              <span id="lf-checklist-name" class="lf-text-label" title="{{ checklist.name }}">{{
                checklist.name
              }}</span>
            </div>
            @if (checklist.checklistItems.length > 0) {
              <lfint-items-component
                [items]="checklist.checklistItems"
                (itemsChanged)="emitChecklistChanges()"
              ></lfint-items-component>
            }
            @if (checklist.checklistOptions.length > 0) {
              <lfint-options-component
                [options]="checklist.checklistOptions"
                (optionsChanged)="emitChecklistChanges()"
              ></lfint-options-component>
            }
          </div>
        }
        @if (checklist.collapsible) {
          <div>
            <mat-expansion-panel [expanded]="false" class="checklist-expansion-panel">
              <mat-expansion-panel-header class="checklist-expansion-panel">
                <mat-panel-title>
                  <span id="lf-checklist-name" class="lf-text-label" title="{{ checklist.name }}">{{
                    checklist.name
                  }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if (checklist.checklistItems.length > 0) {
                <lfint-items-component
                  [items]="checklist.checklistItems"
                  (itemsChanged)="emitChecklistChanges()"
                ></lfint-items-component>
              }
              @if (checklist.checklistOptions.length > 0) {
                <lfint-options-component
                  [options]="checklist.checklistOptions"
                  (optionsChanged)="emitChecklistChanges()"
                ></lfint-options-component>
              }
            </mat-expansion-panel>
          </div>
        }
      </div>
    }
  </div>
  <div id="lf-checklist-button-container" class="lf-checklist-button-container">
    @if (action_button_text) {
      <button
        id="lf-checklist-action-button"
        class="lf-checklist-action-button primary-button lf-button"
        (click)="onActionButtonClicked()"
      >
        {{ action_button_text }}
      </button>
    }
    @if (cancel_button_text) {
      <button
        id="lf-checklist-cancel-button"
        class="lf-checklist-cancel-button lf-button sec-button"
        (click)="onCancelButtonClicked()"
      >
        {{ cancel_button_text }}
      </button>
    }
  </div>
</div>
